import $ from 'jquery';
import loadingLayer from '../util/loadingLayer';

export default {
    init() {
        this.searchPost();
        this.searchPage();
    },

    searchPage() {
        $('.block-search-result').on('click', '.searching-page ul.pagination li a', function(event) {
            event.stopImmediatePropagation();
            event.preventDefault();

            loadingLayer.showLoading();

            const page = $(this).data('page');
            const url = $(this).attr('href');

            $.ajax({
                url,
                method: 'post',
                data: {
                    currentPage: page,
                    nonce: window.meta_object.nonce,
                    action: 'searching-page',
                },
                dataType: 'html',
                complete: function () {
                    loadingLayer.hideLoading();
                },
                success: function (data) {
                    if (!data) return;
                    $('.searching-page', '.block-search-result').html(data);
                    
                },
                error: function(err) {
                    console.log('error', err);
                },
            });
        });
    },

    searchPost() {
        $('.block-search-result').on('click', '.searching-post ul.pagination li a', function(event) {
            event.stopImmediatePropagation();
            event.preventDefault();

            loadingLayer.showLoading();

            const page = $(this).data('page');
            const url = $(this).attr('href');

            $.ajax({
                url,
                method: 'post',
                data: {
                    currentPage: page,
                    nonce: window.meta_object.nonce,
                    action: 'searching-post',
                },
                dataType: 'html',
                complete: function () {
                    loadingLayer.hideLoading();
                },
                success: function (data) {
                    if (!data) return;
                    $('.searching-post', '.block-search-result').html(data);
                },
                error: function(err) {
                    console.log('error', err);
                },
            });
        });
    },

    finalize() {
    // JavaScript to be fired on the home page, after the init JS
    },
}


// WEBPACK FOOTER //
// ./scripts/routes/search.js